import module from './bedford-list.module';
import './bedford-list.controller';

export default module.name;
